import React from 'react';
import {
  Box,
  Typography,
  Stack,
  useTheme,
  useMediaQuery,
  Container
} from '@mui/material';
import { motion } from 'framer-motion';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import ContactForm from './forms/ContactForm';

const ContactUsSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      id="contact"
      sx={{
        background: 'linear-gradient(135deg,rgb(239, 239, 239,0.85) 0%,rgb(38, 190, 99,0.7) 100%)',
        py: { xs: 8, md: 12 },
        px: 3,
        color: '#1b5e20',
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Container maxWidth="md">
          {/* Heading */}
          <Typography
            variant="h4"
            fontWeight="bold"
            textAlign="center"
            sx={{
              fontFamily: 'Playfair Display, serif',
              mb: 2,
              color: '#1b5e20',
            }}
          >
            Get in Touch
          </Typography>

          <Typography
            variant="body1"
            textAlign="center"
            sx={{
              maxWidth: 650,
              mx: 'auto',
              mb: 6,
              color: 'rgba(0,0,0,0.65)',
            }}
          >
            Have questions, feedback, or need support?  
            We’d love to hear from you 🌿
          </Typography>

          {/* Contact Info */}
          <Stack
            direction={isMobile ? 'column' : 'row'}
            spacing={isMobile ? 4 : 8}
            justifyContent="center"
            alignItems="center"
            sx={{ mb: 6 }}
          >
            <Stack alignItems="center" spacing={1}>
              <EmailOutlinedIcon sx={{ fontSize: 42, color: '#2e7d32' }} />
              <Typography variant="subtitle1">info@mazingiraguard.org</Typography>
            </Stack>

            <Stack alignItems="center" spacing={1}>
              <PhoneInTalkOutlinedIcon sx={{ fontSize: 42, color: '#2e7d32' }} />
              <Typography variant="subtitle1">+254 725 499 649</Typography>
            </Stack>

            <Stack alignItems="center" spacing={1}>
              <VerifiedUserOutlinedIcon sx={{ fontSize: 42, color: '#2e7d32' }} />
              <Typography variant="subtitle1">Reliable Support</Typography>
            </Stack>
          </Stack>

          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
              <ContactForm />
          </motion.div>

          {/* Footer Note */}
          <Typography
            variant="body2"
            sx={{
              mt: 6,
              fontStyle: 'italic',
              color: 'rgba(0,0,0,0.6)',
              textAlign: 'center',
            }}
          >
            Together, we protect our planet 🌍💚
          </Typography>
        </Container>
      </motion.div>
    </Box>
  );
};

export default ContactUsSection;
